<template >
<div class="container-fluid" v-if="lesson">
   
   <div class="row">
     <div class="col-md-8 col-sm-12">

      <div class="card mb-4" v-for="(group) in groups"  v-if="groups && groups.length>0">
        <div class="card-header py-3">
          <div class="row">
            <div class="col">
              <h3 class="m-0 font-weight-bold text-primary">{{group.schoolName}}</h3>
            </div>

          </div>
        </div>
        <div class="card-body" >
          <p class="m-0 font-weight-bold text-primary">{{group.schoolName}} - {{group.departmentName}} - {{group.programName}}</p>
          <table class="table table-bordered" id="dataTable" width="100%" cellspacing="0" v-if="group.students && group.students.length>0">
              <thead>
                <tr>
                  <th>№</th>
                  <th>Сурагч</th>
                  <th v-if="topics && topics.length>0" v-for="topic in group.topics">
                    {{topic.name}}
                    <br/>
                    <span v-if="topic.attendance">Хичээл орох: {{topic.attendance.date | formatDate}}</span><br/>
                    <span v-if="topic.attendance && topic.attendance.startDate">Эхэлсэн: {{topic.attendance.startDate | formatDate}}</span>
                    <br/>
                    <span v-if="topic.attendance && topic.attendance.hozorson">Хоцорсон: {{topic.attendance.hozorson}} минут</span>
                    
                    <br/>
                    <!-- <button @click="setForTeacher(topic, group)" v-if="!topic.attendance || !topic.attendance.hozorson" class="btn btn-sm btn-success">цаг бүртгэх</button> -->
                  </th>

                  <!-- <th>Төлөв</th> -->
                  <!-- <th>Үйлдэл</th> -->

                </tr>
              </thead>

              <tbody>
                <tr v-for="(std, index) in group.students" v-bind:key="std.id">
                  <td>{{index+1}}</td>
                  <td>
                    <span v-if="std!=null">{{std.lastname}}/{{std.name}}</span><br/>
                    <span v-if="std!=null">{{std.code}}</span><br/>
                    <span v-if="std!=null">{{std.register}}</span>
                  </td>
                  <td v-if="std && std.topics" v-for="stTopic in std.topics">

                    <span v-if="stTopic && stTopic.attendance && stTopic.attendance.status" class="text-white">

                      <div v-if="stTopic.attendance.status=='active'" class="bg-success">ирсэн</div>
                      <div v-if="stTopic.attendance.status=='off'" class="bg-danger">ирээгүй</div>
                      <div v-if="stTopic.attendance.status=='ill'" class="bg-info">өвчтэй</div>
                      <div v-if="stTopic.attendance.status=='release'" class="bg-warning">чөлөөтэй</div>

                    </span>
                    <span v-else>
                      <span  class="badge badge-pill badge-info" >тодорхойгүй</span>
                      
                    </span>
                  </td>

                  <!-- <td>
                    <span v-if="std.enabled==true" class="badge badge-pill badge-success">идэвхтэй</span>
                    <span v-else class="badge badge-pill badge-danger">блоклосон</span>
                  </td> -->
                  <!-- <td> -->

                    <!-- <button class='btn btn-sm btn-danger' @click="removeStudent(std)">хасах</button>
                    <button v-if="std.enabled==true" class='btn btn-sm btn-primary  mx-1' @click="setEnabledForStudent(std, false)">эрх хаах</button>
                    <button v-else class='btn btn-sm btn-primary mx-1' @click="setEnabledForStudent(std, true)">эрх нээх</button> -->
                  <!-- </td> -->
                </tr>
                
              </tbody>
            </table>
        

        </div>
      </div>
      <div v-else class="alert alert-warning text-center mb-4"><h4>Та одоогоор ямар нэгэн сэдэв оруулаагүй байна.</h4></div>
      <hr class="mb-5"/>
      
      </div>
     <div class="col-md-4 col-sm-12">
       <lesson-info :lesson="lesson" :schoolId="schoolId" :edit="false" :showDetail="false"></lesson-info>
     </div>
   </div>
</div>
    
</template>

<script>
const fb = require('../../../firebaseConfig.js')
import { mapState } from 'vuex'
import moment from 'moment'
import firebase from 'firebase'
import VueQrcode from 'vue-qrcode';
import LessonInfo from '../shared/LessonInfo';
export default {
    name: "SLessonGroupStudents",

    data() {
        return {
            lesson: null,
            topics:[],
            selectedType:null,
            studentsText:'',
            selectedTopic:null,
            tmpStudents:[],

            display:0,
            tagText:null,
            schools:[],
            school:null,
            department:null,
            program:null,
            groups:[]
            
        };
    },
    methods: {
        
      async _getQA(){
        var doc=await fb.db.collection("schools/"+this.schoolId+"/lessons").doc(this.lessonId).get();
        let lesson=doc.data();
        lesson.id=doc.id;
        
        await this._getTopics();

        if(lesson && lesson.groups && lesson.groups.length>0){
          var tmp=[];
          for(const group of lesson.groups){
            if(group.program.id==this.groupId){
              group.students=[];
              group.topics=[];
              for(const topic of this.topics){
                let item= Object.assign({}, topic);
                item.attendance=null;
                
                fb.db.doc("schools/"+this.schoolId+"/lessons/"+this.lessonId+"/topics/"+topic.id+"/groups/"+group.program.id).onSnapshot(atDoc=>{
                  if(atDoc.exists){
                    let atItem=atDoc.data();
                    atItem.id=atDoc.id;
                    atItem.ref=atDoc.ref;
                    item.attendance=atItem;
                  }
                });

                group.topics.push(item);
              }
              this._getStudents(group);
              tmp.push(group);
            }
          }
          this.groups=tmp;

        }

        this.lesson=lesson;

      },
      async _getStudents(group){
        var snapshot=await fb.db.collection("schools/"+this.schoolId+"/students").where("program", "==", group.program).get();
        for(const studentDoc of snapshot.docs){
          if(studentDoc.exists){
            let student=studentDoc.data();
            student.id=studentDoc.id;
            student.ref=studentDoc.ref;
            student.topics=[];

            for(const topic of this.topics){
              let item= Object.assign({}, topic);
              item.attendance=null;
              
              fb.db.doc("schools/"+this.schoolId+"/lessons/"+this.lessonId+"/studentList/"+studentDoc.id+"/attendance/"+topic.id).onSnapshot(atDoc=>{
                if(atDoc.exists){
                  let atItem=atDoc.data();
                  atItem.id=atDoc.id;
                  atItem.ref=atDoc.ref;
                  item.attendance=atItem;
                }
              });

              student.topics.push(item);
            }
            group.students.push(student);
          }
        }
      },
      async _getTopics(){
        var snapshot=await fb.db.collection("schools/"+this.schoolId+"/lessons/"+this.lessonId+"/topics").orderBy("createdAt").get();
        this.topics=[];
        for(const topicDoc of snapshot.docs){
          if(topicDoc.exists){
            let topic=topicDoc.data();
            topic.ref=topicDoc.ref;
            topic.id=topicDoc.id;

            this.topics.push(topic);
          }
        }
      },

      addStudents(){
        if(this.studentsText!=null && this.studentsText!=''){

          var arrayOfLines = this.studentsText.match(/[^\r\n]+/g);
          arrayOfLines.forEach(value=>{
            // console.log(value);
            var lineArray=value.split(/\s+/);
            console.log(lineArray)
            if(lineArray!=null && lineArray.length==2 && lineArray[0]!=null && lineArray[0]!='' && lineArray[1]!=null && lineArray[1]!=''){
              var lessonRef= fb.db.collection("schools/"+this.schoolId+"/lessons").doc(this.lessonId);
              var studentRef=fb.db.collection("schools/"+this.schoolId+"/students").doc(lineArray[0].toLowerCase()).get().then(studentData=>{
                var studentDetail;
                var saveStudent=true;
                if(studentData!=null && studentData.exists){
                  // studentData.ref.update({
                    // 'lessons': fb.firestore.FieldValue.arrayUnion(lessonRef)
                  // });
                  studentDetail=studentData.data();
                  this.addStudentToLesson(lessonRef, studentData, studentDetail);
                }
                else{
                  fb.db.collection("schools/"+this.schoolId+"/students").where("register", "==", lineArray[1].toLowerCase()).get().then(value=>{
                    if(value.empty)
                    {
                      studentDetail={
                        'code':lineArray[0].toLowerCase(),
                        'register': lineArray[1].toLowerCase(),
                        // 'lessons': fb.firestore.FieldValue.arrayUnion(lessonRef),
                        'created': fb.usersCollection.doc(this.$store.getters.currentUser.uid),
                        'createdAt': new Date()
                      };
                      studentData.ref.set(
                        studentDetail
                      );
                      this.addStudentToLesson(lessonRef, studentData, studentDetail);
                    }
                  });
              
                }
                
              });

            }
          });
          this.studentsText=''
        }
      },
      addStudentToLesson(lessonRef, studentData, studentDetail){
        studentData.ref.collection("lessonList").doc(lessonRef.id).get().then(stLesson=>{
          if(stLesson!=null && stLesson.exists){

          }
          else{
            studentData.ref.collection("lessonList").doc(lessonRef.id).set({
              lessonRef: lessonRef,
              addedDate: new Date(),
              addedUser: fb.usersCollection.doc(this.$store.getters.currentUser.uid),
              enabled:true,
              semester: this.lesson.semester
            })
          }
        });
        
        lessonRef.collection("studentList").doc(studentData.id).get().then(lessonSt=>{
          if(lessonSt!=null && lessonSt.exists){

          }
          else{
            lessonRef.update({
              'numberOfStudents': fb.firestore.FieldValue.increment(1)
            });
            lessonRef.collection("studentList").doc(studentData.id).set({
              addedDate:new Date(),
              addedUser: fb.usersCollection.doc(this.$store.getters.currentUser.uid),
              studentRef: studentData.ref,
              enabled:true,
              semester: this.lesson.semester
            })
          }
        });
      },
      _addTopic(){
        this.school=null;
        this.department=null;
        this.program=null;
        $('#exampleModal').modal('toggle');
      },
      deleteForStudent(old, topic, student, stindex, index){

        this.setProperty("status", fb.db.doc("schools/"+this.schoolId+"/lessons/"+this.lessonId+'/studentList/'+student.id+"/attendance/"+topic.id), null);
        if(topic.attendance.status=="active"){
          fb.db.doc("schools/"+this.schoolId+"/lessons/"+this.lessonId+'/topics/'+topic.id).update({"numberOfArrived": fb.firestore.FieldValue.increment(-1)});
          fb.db.doc("schools/"+this.schoolId+"/lessons/"+this.lessonId).update({"numberOfArrived": fb.firestore.FieldValue.increment(-1)});
           
        }
        else if(topic.attendance.status=="off"){
          fb.db.doc("schools/"+this.schoolId+"/lessons/"+this.lessonId+'/topics/'+topic.id).update({"numberOfNotArrived": fb.firestore.FieldValue.increment(-1)});
          fb.db.doc("schools/"+this.schoolId+"/lessons/"+this.lessonId+'/topics/'+topic.id).update({"numberOfOff": fb.firestore.FieldValue.increment(-1)});
          fb.db.doc("schools/"+this.schoolId+"/lessons/"+this.lessonId).update({"numberOfNotArrived": fb.firestore.FieldValue.increment(-1)});
          
        }
        else if(topic.attendance.status=="ill"){
          fb.db.doc("schools/"+this.schoolId+"/lessons/"+this.lessonId+'/topics/'+topic.id).update({"numberOfNotArrived": fb.firestore.FieldValue.increment(-1)});
          fb.db.doc("schools/"+this.schoolId+"/lessons/"+this.lessonId+'/topics/'+topic.id).update({"numberOfIll": fb.firestore.FieldValue.increment(-1)});
          fb.db.doc("schools/"+this.schoolId+"/lessons/"+this.lessonId).update({"numberOfNotArrived": fb.firestore.FieldValue.increment(-1)});
          
        }
        else if(topic.attendance.status=="release"){
          fb.db.doc("schools/"+this.schoolId+"/lessons/"+this.lessonId+'/topics/'+topic.id).update({"numberOfNotArrived": fb.firestore.FieldValue.increment(-1)});
          fb.db.doc("schools/"+this.schoolId+"/lessons/"+this.lessonId+'/topics/'+topic.id).update({"numberOfRelease": fb.firestore.FieldValue.increment(-1)});
          fb.db.doc("schools/"+this.schoolId+"/lessons/"+this.lessonId).update({"numberOfNotArrived": fb.firestore.FieldValue.increment(-1)});
          
        }
      },
      setForStudent(value, topic, student, stindex, index){

        this.setProperty("status", fb.db.doc("schools/"+this.schoolId+"/lessons/"+this.lessonId+'/studentList/'+student.id+"/attendance/"+topic.id), value);
        // this.$set(this.students[stindex]['attendances'], index, value);
        if(value=="active"){
          fb.db.doc("schools/"+this.schoolId+"/lessons/"+this.lessonId+'/topics/'+topic.id).update({"numberOfArrived": fb.firestore.FieldValue.increment(1)});
          fb.db.doc("schools/"+this.schoolId+"/lessons/"+this.lessonId).update({"numberOfArrived": fb.firestore.FieldValue.increment(1)});
          
        }
        else if(value=="off"){
          fb.db.doc("schools/"+this.schoolId+"/lessons/"+this.lessonId+'/topics/'+topic.id).update({"numberOfNotArrived": fb.firestore.FieldValue.increment(1)});
          fb.db.doc("schools/"+this.schoolId+"/lessons/"+this.lessonId+'/topics/'+topic.id).update({"numberOfOff": fb.firestore.FieldValue.increment(1)});
          fb.db.doc("schools/"+this.schoolId+"/lessons/"+this.lessonId).update({"numberOfNotArrived": fb.firestore.FieldValue.increment(1)});
        }
        else if(value=="ill"){
          fb.db.doc("schools/"+this.schoolId+"/lessons/"+this.lessonId+'/topics/'+topic.id).update({"numberOfNotArrived": fb.firestore.FieldValue.increment(1)});
          fb.db.doc("schools/"+this.schoolId+"/lessons/"+this.lessonId+'/topics/'+topic.id).update({"numberOfIll": fb.firestore.FieldValue.increment(1)});
          fb.db.doc("schools/"+this.schoolId+"/lessons/"+this.lessonId).update({"numberOfNotArrived": fb.firestore.FieldValue.increment(1)});
        }
        else if(value=="release"){
          fb.db.doc("schools/"+this.schoolId+"/lessons/"+this.lessonId+'/topics/'+topic.id).update({"numberOfNotArrived": fb.firestore.FieldValue.increment(1)});
          fb.db.doc("schools/"+this.schoolId+"/lessons/"+this.lessonId+'/topics/'+topic.id).update({"numberOfRelease": fb.firestore.FieldValue.increment(1)});
          fb.db.doc("schools/"+this.schoolId+"/lessons/"+this.lessonId).update({"numberOfNotArrived": fb.firestore.FieldValue.increment(1)});
        }
      },

      setEnabledForStudent(stddata, value){
        this.setProperty("enabled", stddata.ref, value);
        this.setProperty("enabled", fb.db.doc("schools/"+this.schoolId+"/students/"+stddata.id+"/lessonList/"+this.lessonId), value);
        
      },
      setProperty(propertyName, object, value){
        if(object!=null && propertyName!=null){
          var tmp={};
          tmp[propertyName]=value;
          object.set(tmp, {merge:true});
        }
      },
      removeStudent(stddata){
        fb.db.doc("schools/"+this.schoolId+"/students/"+stddata.id+"/lessonList/"+this.lessonId).delete();
        stddata.ref.delete();
        fb.db.collection("schools/"+this.schoolId+"/lessons").doc(this.lessonId).update({
          'numberOfStudents': fb.firestore.FieldValue.increment(-1)
        });

      },
 


        _addProgram(){
          if(this.school!=null && this.school!=undefined && this.department!=null && this.department!=undefined && this.program!=null && this.program!=undefined){
            var exists=false;
            if(this.lesson!=null && this.lesson!=undefined && this.lesson.groups!=null && this.lesson.groups!=undefined && this.lesson.groups.length>0){
              for(const tmp of this.lesson.groups){
                if(tmp!=null && tmp!=undefined && tmp.program!=null && tmp.program!=undefined && tmp.program.id==this.program.id){
                  exists=true;
                }
              }
            }
            if(exists==false){
              fb.db.collection("schools/"+this.schoolId+"/lessons").doc(this.lesson.id).update({
                groups: fb.firestore.FieldValue.arrayUnion(
                  {
                    school: this.school.ref,
                    department: this.department.ref,
                    program: this.program.ref,
                    schoolName: this.school.data().name,
                    departmentName: this.department.data().name,
                    programName: this.program.data().name
                  }
                )
              });
              this.findStudents(this.school.ref, this.department.ref, this.program.ref);
            }
            else{
              alert("Аль хэдийн нэмэгдсэн байна.");
            }
          }
          else{
            alert("Та мэдээллээ бүрэн оруулна уу.");
          }
        },
        findStudents(sc, dep, pro){
          fb.db.collection("schools/"+this.schoolId+"/students").where("school", "==", sc).where("department", "==", dep).where("program", "==", pro).get().then(docs=>{
            for(const studentData of docs.docs){
              
              if(studentData!=null && studentData.exists){
                var studentDetail=studentData.data();
                this.addStudentToLesson(fb.db.collection("schools/"+this.schoolId+"/lessons").doc(this.lesson.id), studentData, studentDetail);
              }
            }
          });
        }
    },
    computed: {
        ...mapState(['userProfile', 'currentUser'])
    },
    components: {
      VueQrcode,
      LessonInfo
    },
    props: {
      schoolId:{
        required:true
      },
      lessonId: { 
          required: true,
      },
      groupId:{
        required:true
      }
    },
    created() {
        var _this=this;
        if(this.lessonId!=null && this.lessonId!=''){
          this._getQA();
        }
            
    },
    filters: {
		  formatDate(val) {
          if (!val) { return '-' }
          let date = val.toDate()
          return moment(date).format('MM/DD/YYYY HH:mm');
      },
    }
  
};
</script>

